/**
 * Shared configuration constants
 * Used by both production and staging configs
 */

export const matterport = {
	sdkVersion: '3.5',
	sdkKey: '751c857ee3374fad8646b721053e2d4f',
	disabled: false
};

/**
 * Shared Sentry configuration
 */
export const sentrySha = {
	ignoreErrors: [
		//https://tablzinc.sentry.io/issues/6617582685
		'evaluating \'window.webkit.messageHandlers\'',
		//Matterport bundle SDK specific, network-related, non-addressable error.
		'Loading CSS chunk',
		//Outlook safe link triggered: https://github.com/getsentry/sentry-javascript/issues/3440
		'Non-Error promise rejection captured',
		// Random plugins/extensions
		'top.GLOBALS',
		// See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
		'originalCreateNotification',
		'canvas.contentDocument',
		'MyApp_RemoveAllHighlights',
		'http://tt.epicplay.com',
		'Can\'t find variable: ZiteReader',
		'jigsaw is not defined',
		'ComboSearch is not defined',
		'http://loading.retry.widdit.com/',
		'atomicFindClose',
		// Facebook borked
		'fb_xd_fragment',
		// ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
		// reduce this. (thanks @acdha)
		// See http://stackoverflow.com/questions/4113268
		'bmi_SafeAddOnload',
		'EBCallBackMessageReceived',
		// See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
		'conduitPage',
		//Common unrelevant Tablz Errors
		'https://i.imgur.com/',
		'Network Error',
		'network error',
		'safari-web-extension',
		'BetterJsPop',
		'gtag/js',
		'Failed to get document because the client is offline.',
		'INTERNAL ASSERTION FAILED: Unexpected state',
		'We could not retrieve data from the specified Element. Please make sure the Element you are attempting to use is still mounted',
		'Unable to fetch the sdk interface.',
		'webkit-masked-url',
		'ResizeObserver loop limit exceeded',
		'InvalidAccessError: Page already has an active payment session.',
		'Loading chunk',
		//disable internal matterport error
		'/bundle/js/',
		'/bundle/sdk/',
		'The network connection was lost',
		'Database deleted by request of the user',
		'Timeslot no longer available. Please select another.'
	],
	denyUrls: [
		// Facebook flakiness
		/graph\.facebook\.com/i,
		// Facebook blocked
		/connect\.facebook\.net\/en_US\/all\.js/i,
		// Woopra flakiness
		/eatdifferent\.com\.woopra-ns\.com/i,
		/static\.woopra\.com\/js\/woopra\.js/i,
		//Safari Extensions
		/safari-web-extension/i,
		/safari-extension:\/\//i,
		// Chrome extensions
		/extensions\//i,
		/^chrome:\/\//i,
		// Other plugins
		/127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
		/webappstoolbarba\.texthelp\.com\//i,
		/metrics\.itunes\.apple\.com\.edgesuite\.net\//i
	]
};
